import { render } from "./TopBarCustomer.vue?vue&type=template&id=505f319f&scoped=true"
import script from "./TopBarCustomer.vue?vue&type=script&lang=js"
export * from "./TopBarCustomer.vue?vue&type=script&lang=js"

import "./TopBarCustomer.vue?vue&type=style&index=0&id=505f319f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505f319f"]])

export default __exports__